var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"backfade"}},[(_vm.show)?_c('div',{staticClass:"text-center",attrs:{"id":"loading"}},[_c('img',{attrs:{"src":"/images/loading.gif"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }